// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"a0616324","493":"5e18e551","517":"efbf8f23","724":"41eaaa5a","980":"e0542c40"}[chunkId] + ".chunk.js";
};